import { Immutable } from "@hookstate/core";
import { forwardRef, useMemo } from "react";
import { FilterTagButton } from "../../../../components/buttons/FilterTag";
import { TextIcon } from "../../../../components/icons/TextIcon";
import { LanguageEntity } from "../../../../services/gc/types";
import { Option } from "../../../../types";
import { FilterTitle } from "../../../../components/filters/FilterTitle";
import { RadioFilter } from "../../../../components/filters/RadioFilter";

export const LANGUAGE_ALL = "0";

interface LanguageFacetGroupFilterProps {
  value: Immutable<string | undefined>;
  languages: LanguageEntity[];
  onChange: (nextValue: string) => void;
  tinted?: boolean;
}
export function LanguageFacetGroupFilter({
  value,
  languages,
  onChange,
  tinted,
}: LanguageFacetGroupFilterProps) {
  const languageOptions: Option<string>[] = useMemo(() => {
    let options = languages.map((type) => ({
      label: type.name,
      value: "" + type.id,
    }));

    return [
      { label: "All", value: LANGUAGE_ALL },
      ...options.sort((a, b) => a.label.localeCompare(b.label)),
    ];
  }, []);

  return (
    <RadioFilter value={value} options={languageOptions} onChange={onChange} tinted={tinted} />
  );
}

interface LanguageFacetGroupFilterTitleProps {
  isTrigger: boolean;
  languages: LanguageEntity[];
  activeValue?: Immutable<string | undefined>;
  open?: boolean;
}
export const LanguageFacetGroupFilterTitle = forwardRef(
  (
    {
      isTrigger,
      languages,
      activeValue,
      open,
      ...props
    }: LanguageFacetGroupFilterTitleProps,
    ref,
  ) => {
    const language = languages.find(
      (language) => `${language.id}` == (activeValue as unknown as string),
    );
    if (isTrigger) {
      return (
        <FilterTagButton
          icon={<TextIcon />}
          popoverRef={ref}
          text="Language"
          isFiltering={language?.name}
          {...props}
        />
      );
    }
    return (
      <FilterTitle
        text="Language"
        activeFilters={activeValue && activeValue !== LANGUAGE_ALL ? 1 : 0}
        open={open}
        icon={<TextIcon boxSize="24px" color="neutral.400" />}
      />
    );
  },
);
